export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VideoModal.vue?vue&type=template&id=1b72bcac&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/VideoModal.vue?vue&type=template&id=1b72bcac&scoped=true
// module id = 220
// module chunks = 0